/* 🤖 this file was generated by svg-to-ts */
export const matIconModeComment: {
  name: 'mode-comment';
  data: string;
} = {
  name: 'mode-comment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 17.17 18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"/></svg>`
};
